import { Client } from '@src/common/services/Client';
import { AxiosResponseConverter } from '@src/documents/AxiosResponseConverter';

export const PublicDocumentClient = {
  download: async (
    token: string,
    filename: string,
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await Client.get<Blob>('/public/documents', {
      params: { token },
      responseType: 'blob',
    });

    const blob = AxiosResponseConverter.toBlob(response);

    return { blob, filename };
  },
};
